import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

export const salesRoutes:Routes=[
    {
        path:'',
        children:[
            {
                path: '',
                loadComponent:() =>
                    import('./sales-list/sales-list.component').then((m)=>m.SalesListComponent),
               
            },
            {
                path: 'cliente/:name/:id',
                loadComponent:() =>
                    import('./sales-modal-detail-sales/sales-modal-detail-sales.component').then((m)=>m.SalesModalDetailSalesComponent),
            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(salesRoutes)], 
    exports: [RouterModule] 
  })
  export class SalesRoutingModule {}
